<template>
  <div>
    <v-row class="mx-1 saved-lineup">
      <v-col cols="12" md="4" sm="12">
        <!-- //? slate filter -->
        <v-row class="mt-2 mt-2 d-none d-md-flex" justify="center">
          <v-col
            cols="4"
            md="3"
            sm="3"
            class="caption text-sm-center text-md-center text-end mt-n4 mr-sm-n6"
          >
            <b>Slate Time NBA:</b>
          </v-col>
          <v-col cols="6" md="5" sm="4">
            <v-select
              light
              :items="Slates"
              item-text="OperatorName"
              item-value="SlateID"
              v-model="slateId"
              solo
              dense
              @change="saveBuilds"
            >
              <template v-slot:item="{ item }">
                <small class="caption">
                  {{ item.OperatorName }}&nbsp;
                  {{ item.OperatorStartTime | timeFormat }}
                  ({{ item.NumberOfGames }}games)
                </small>
              </template>
            </v-select>
            <!-- <small>{{ operator }}</small>
                <small>{{ operatorGameType }}</small> -->
          </v-col>
          <!-- Selector ends -->

          <!-- Radio buttons -->
          <v-col cols="6" md="5" sm="5" class="mt-md-n6 mt-n2" align="center">
            <v-radio-group v-model="radio" row>
              <v-radio
                label="Classic"
                value="classic"
                @change="onlyClassic()"
              ></v-radio>
              <v-radio
                label="Single Game"
                value="others"
                @change="otherThanClassic()"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <!-- Radio buttons ends -->
        </v-row>
        <!-- only for mobile dvices start -->

        <v-row class="mt-2 d-block d-md-none" justify="center">
          <!-- Radio buttons -->
          <v-col cols="5" md="4" sm="5" class="cus-radio-bnt float-left">
            <v-radio-group v-model="radio" row>
              <v-radio
                label="Classic"
                value="classic"
                @change="onlyClassic()"
              ></v-radio>
              <v-radio
                label="Single Game"
                value="others"
                @change="otherThanClassic()"
              ></v-radio>
            </v-radio-group>
          </v-col>
          <!-- Radio buttons ends -->

          <!-- //? slate filter -->
          <v-col
            cols="7"
            md="4"
            sm="5"
            class="text-sm-center text-md-center text-end mt-n4 mr-sm-n6 float-right cus-caption-6"
            align-self="center"
          >
            <strong>Slate Time NBA:</strong>
            <v-select
              light
              :items="Slates"
              item-text="OperatorName"
              item-value="SlateID"
              v-model="slateId"
              solo
              dense
              @change="saveBuilds"
            >
              <template v-slot:item="{ item }">
                <small class="caption">
                  {{ item.OperatorName }}&nbsp;
                  {{ item.OperatorStartTime | timeFormat }}
                  ({{ item.NumberOfGames }}games)
                </small>
              </template>
            </v-select>
            <!-- <small>{{ operator }}</small>
                <small>{{ operatorGameType }}</small> -->
          </v-col>
          <!-- Selector ends -->
        </v-row>
        <!-- //? slate filter ends -->
        <!-- only for mobile dvices end -->

        <!-- //? slate filter ends -->

        <base-title-bar
          elevation="3"
          class="text-center cus-clearfix"
          color="#17408B"
          label="Builds"
          icon="mdi-star"
        />
        <v-list v-if="saveBuild.doc.length > 0">
          <v-list-item-group v-model="selected">
            <template v-for="(item, index) in this.saveBuild.doc">
              <v-list-item :key="item._id" @change="showLineUp(item._id)">
                <template v-slot:default="{ active }">
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="2" md="2" sm="2">
                        <v-avatar size="40" color="#ECEFF1" class="mt-n2">
                          <v-icon>mdi-package-variant</v-icon>
                        </v-avatar>
                      </v-col>
                      <v-col cols="4" md="4" sm="4">
                        <v-list-item-title
                          class="body-2 ml-5"
                          v-text="'Build' + ' ' + (index + 1)"
                        ></v-list-item-title>
                      </v-col>
                      <v-col cols="4" md="5" sm="4">
                        <v-list-item-subtitle
                          class="body-2"
                          v-text="'(Teams:' + ' ' + item.length + ')'"
                        ></v-list-item-subtitle>
                        <v-list-item-subtitle
                          class="caption"
                          v-text="item.operator"
                        ></v-list-item-subtitle>
                      </v-col>
                    </v-row>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-list-item-action-text>
                      {{ item.day | dayFormat }}
                    </v-list-item-action-text>

                    <v-icon v-if="!active" color="grey lighten-1">
                      mdi-arrow-right-bold-circle-outline
                    </v-icon>

                    <v-icon v-else color="green darken-2">
                      mdi-arrow-right-bold-circle
                    </v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>
              <v-divider />
            </template>
          </v-list-item-group>
        </v-list>
        <v-col v-else cols="12" md="12" sm="12">
          <h3 class="text-center body-1">
            No Saved Lineup for now <br />
            Please save a LineUp first.
          </h3>
        </v-col>
        <!-- <p>{{ all_lineup_teams }}</p> -->
        <!-- <p>{{ selected }}</p> -->
        <!-- <p>{{ operator }}&{{ gameType }}</p> -->
      </v-col>
      <v-col cols="12" md="8" sm="12" class="line-up-data">
        <saved-line-up
          :LineupBuild="this.LineUpTeam"
          ref="line_up_teams"
          :saveBuildId="saveBuildId"
        />
      </v-col>
    </v-row>

    <!-- update Modal -->
    <div v-if="UpgradeModal" class="upgrade-dialog">
      <v-dialog
        overlay-opacity="0.97"
        persistent
        v-model="UpgradeModal"
        max-width="350"
        class="blur"
      >
        <v-card>
          <v-toolbar dense color="#00E676" class="text-h6" dark>
            Get Full Access
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text class="text-center text-h6 font-weight-bold pa-1">
            Upgrade Now & Get Access to ALL Features.
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue darken-1 white--text" text @click="goBack">
              No, Thanks
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1 white--text" text @click="goToUpgrade">
              Upgrade Now
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- update Modal ends..-->
  </div>
</template>

<script>
import { mapState } from "vuex";

// import savedLineUp from '@/components/Tables/savedLineUp.vue';
const savedLineUp = () => import("@/components/Tables/savedLineUp.vue");

export default {
  components: { savedLineUp },
  name: "nbaSavedLineup",
  props: ["allSlate"],

  data: () => ({
    radio: "others",
    Slates: [],
    slateId: "",
    saveBuildId: "",
    UpgradeModal: false,
    userId: localStorage.getItem("user"),
    LineUpTeam: [],
    selected: 0,
    selected_lineup: [],
    all_lineup_teams: [],
  }),

  async created() {
    if (this.radio == "classic") {
      this.onlyClassic();
    }
  },

  beforeMount() {
    if (this.userState) {
      if (this.userState.plantype == "Free") {
        this.UpgradeModal = true;
      } else {
        this.UpgradeModal = false;
      }
    }
  },

  computed: {
    ...mapState("NbaModule", ["saveBuild"]),
    ...mapState("userModule", ["userState"]),
  },
  methods: {
    showLineUp(id) {
      // uncheck select all checkbox
      this.$refs.line_up_teams.select_all = false;
      if (this.saveBuild.doc[0]?._id) {
        this.$store.dispatch("NbaModule/getLineUpBuild", id).then(() => {
          this.saveBuildId = id;
          this.LineUpTeam = this.$store.state.NbaModule.LineupBuild;
          this.all_lineup_teams[id] = this.LineUpTeam.doc.lineup;
        });
      }
    },

    async saveBuilds() {
      let params = `${this.userId}/${this.slateId}`;
      await this.$store.dispatch("NbaModule/getSavedBuild", params).then(() => {
        let self = this;
        this.$store.state.NbaModule.saveBuild.doc.forEach(function (item) {
          self.selected_lineup.push({ [item._id]: [] });
        });
        this.showLineUp(this.saveBuild.doc[0]._id);
      });
    },

    // ? filter by radio...
    onlyClassic() {
      this.selected_lineup = [];
      this.all_lineup_teams = [];
      let result = this.allSlate.filter(
        (value) => value.OperatorGameType == "Classic"
      );
      this.Slates = result;
      // alert(JSON.stringify(this.Slates));
      this.slateId = this.Slates[0]?.SlateID;
      // this.operator = this.Slates[0]?.Operator;
      // this.$store.state.NbaModule.operator = this.operator;
      // this.operatorGameType = this.Slates[0]?.OperatorGameType;
      // this.$store.state.NbaModule.operatorGameType = this.operatorGameType;
      this.saveBuilds();
    },

    otherThanClassic() {
      this.selected_lineup = [];
      this.all_lineup_teams = [];
      this.Slates = [];
      let result2 = this.allSlate.filter(
        (value) => value.OperatorGameType !== "Classic"
      );
      this.Slates = result2;
      this.slateId = this.Slates[0]?.SlateID;
      // this.operator = this.Slates[0]?.Operator;
      // this.operatorGameType = "Single";
      this.saveBuilds();
    },

    goBack() {
      this.$router.go(-1);
    },

    goToUpgrade() {
      this.$router.push({ name: "upgradePlan" });
    },
  },
};
</script>

<style scoped></style>
